import { InferGetServerSidePropsType } from 'next';

import config from 'config';
import withPageLayout from 'core/hocs/withPageLayout';
import { itShops } from 'consts/shopPages';
import { serverRequests as pageLayoutServerRequests, GetPageLayoutResult } from '@layouts/PageLayout/PageLayout.utils';
import PublicSectorPage from '@pages/PublicSector';
import { getMock } from '@pages/PublicSector/PublicSector.mock';
import {
  trustedUsCountRequestConfig,
  GetTrustedUsCountVariables,
  GetTrustedUsCountResults,
} from 'graphql/queries/GetTrustedUsCount.query';
import { numbersRequestConfig, GetNumbersResults, GetNumbersVariables } from 'graphql/queries/GetNumbers.query';
import { pageRequestConfig, GetPageResults, GetPageVariables } from 'graphql/queries/GetPageData.query';
import {
  pageFilesRequestConfig,
  GetPagesFilesResults,
  GetPagesFilesVariables,
} from 'graphql/queries/GetPagesFiles.query';
import { RequestConfig } from 'utils/combineRequest';
import getCommonServerSideProps from 'utils/getCommonServerSideProps';

const { routes } = config;

const serverRequests: RequestConfig[] = [
  ...pageLayoutServerRequests,
  trustedUsCountRequestConfig,
  pageRequestConfig,
  pageFilesRequestConfig,
  numbersRequestConfig,
];

export const getServerSideProps = getCommonServerSideProps<
  GetPageLayoutResult & GetPageResults & GetPagesFilesResults & GetNumbersResults & GetTrustedUsCountResults,
  GetPageVariables & GetPagesFilesVariables & GetNumbersVariables & GetTrustedUsCountVariables
>(
  routes.publicSector.href,
  serverRequests,
  {
    pages: [routes.publicSector.href],
    numbers: ['COCON_START_YEAR', 'PUBLIC_SECTOR_DELIVERIES_PER_YEAR', 'CLIENTS', 'ALL_DELIVERIES'],
  },
  (v) => v,
  itShops
);

const PublicSector = ({
  trustedUsCount,
  numbers,
}: InferGetServerSidePropsType<typeof getServerSideProps>): JSX.Element => (
  <PublicSectorPage variant="publicSector" numbers={numbers} trustedUsCount={trustedUsCount} {...getMock(numbers)} />
);

export default withPageLayout(PublicSector, {
  breadcrumbVariant: 'publicSector',
  showBreadcrumb: true,
  withoutBreadcrumbBorder: true,
});
